import { observer } from 'mobx-react-lite';
import { PopulatedExperienceTag } from '@/schemas/experience-tag-schema.ts';
import ViewPanel from '@components/view/view-panel.tsx';
import QuickData from '@components/data/quick-data/quick-data.tsx';
import ClassString from '@utils/class-string.ts';

interface ExperienceTagDetailsMainStatsProps {
	tag: PopulatedExperienceTag;
}

const getMinMax = (numbers: number[]): { min: number; max: number } => {
	if (numbers.length === 0) {
		return { min: 0, max: 0 };
	}

	return {
		min: Math.min(...numbers.filter((num) => num > 0)),
		max: Math.max(...numbers),
	};
};

const ExperienceTagDetailsMainStats = observer(
	function ExperienceTagDetailsMainStats(
		props: ExperienceTagDetailsMainStatsProps
	) {
		const { min, max } = getMinMax(
			props.tag.places.map((exp) => exp.like_percentage * 100)
		);

		return (
			<div
				className={ClassString({
					static: 'gap-6 grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-4 w-full',
					dynamic: {},
				})}
			>
				<ViewPanel className={'flex justify-center items-center'}>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							props.tag.places.reduce(
								(a, b) => a + b.players_online || 0,
								0
							)
						)}
						title={'Total Players Online'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel className={'flex justify-center items-center'}>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							props.tag.places.reduce(
								(a, b) => a + b.total_visits || 0,
								0
							)
						)}
						title={'Total Visits'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel className={'flex justify-center items-center'}>
					<QuickData
						className={'m-0'}
						data={new Intl.NumberFormat(navigator.language).format(
							props.tag.places.reduce((a, b) => {
								const fav = b.favorites ?? 0;
								return a + fav || 0;
							}, 0)
						)}
						title={'Total Favorites'}
						size={'small'}
					/>
				</ViewPanel>

				<ViewPanel
					className={'hidden lg:flex justify-center items-center'}
				>
					<QuickData
						className={'m-0'}
						data={`${min.toFixed(2)}% - ${max.toFixed(2)}%`}
						title={'Like Range'}
						size={'small'}
					/>
				</ViewPanel>
			</div>
		);
	}
);

export default ExperienceTagDetailsMainStats;
